import React, { Fragment } from 'react';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import DrawerHeader from 'components/ui/DrawerHeader';

import { getTranslatedString } from 'helpers/i18n';
import { media, sizes } from 'helpers/MediaHelper';
import { drawerStyles } from 'helpers/StyleHelper';

import StatusTag from 'components/ui/StatusTag';

const StyledHeader = styled.div`
  font-family: 'Circular-Black';

  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;

  ${media.mobile`
    text-align: left;
    justify-content: space-between;
  `};
`;

const StyledHeaderWarning = styled.p`
  background: #efefef;
  color: #ff3333;
  margin: 0;
  text-align: center;

  ${media.mobile`
    text-align: left;
    background: white;
    margin-top: 5px;
  `};
`;

const StyledName = styled.p`
  font-size: 30px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin: 0;
`;

const TenantOverviewHeader = ({
  fullName,
  status,
  isPriorOrFutureTenant,
  handleClickBack,
  backgroundColor,
}) => {
  const Header = (
    <StyledHeader>
      <StyledName>{fullName}</StyledName>
      <StatusTag status={status} leftMargin={'16px'} />
    </StyledHeader>
  );

  const Warning = isPriorOrFutureTenant && (
    <StyledHeaderWarning>
      {getTranslatedString('landlordPortal.tenantOverview.thisPerson')}
    </StyledHeaderWarning>
  );

  const background = backgroundColor ? { backgroundColor } : {};

  return (
    <Fragment>
      <MediaQuery query={`(min-device-width: ${sizes.desktop}px)`}>
        <div className="row" style={{ ...drawerStyles.tabbedHeaderWrapper, ...background }}>
          {Header}
          {Warning}
        </div>
      </MediaQuery>

      <MediaQuery query={`(max-device-width: ${sizes.mobile}px)`}>
        <DrawerHeader
          noBorder
          onClose={handleClickBack}
          title={fullName}
          subTitle={getTranslatedString('landlordPortal.tenantOverview.resident')}
          subHeader={Warning}
          status={status}
          backgroundColor={backgroundColor}
        />
      </MediaQuery>
    </Fragment>
  );
};

export default TenantOverviewHeader;
